import React from 'react';
import { useAppSelector } from 'src/redux/hooks';
import PermissionService, { ACTION, ROLE } from 'src/services/permission-service';
import AccessDenied from 'src/components/AccessDenied';

interface RequirePermissionProps {
  action: ACTION;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ action, children }) => {
  const userRole = useAppSelector(s => s.user.user.role) as ROLE;
  if (!PermissionService.getInstance().isAllowed(action, userRole)) {
    return <AccessDenied />;
  }
  return <>{children}</>;
};

export default RequirePermission; 